export class LanguageHelper {
  static convertToLanguage(lang: number) {
    if (lang === 1) {
      return "nl-BE";
    } else if (lang == 2) {
      return "fr-BE";
    } else if (lang == 4) {
      return "de-BE";
    } else {
      return "en-US";
    }
  }
  static convertToI18nLangCode(lang: string) {
      switch(lang) {
          case "en":
              return "en-US";
          case "fr":
              return "fr-BE";
          case "nl":
              return "nl-BE";
          case "de":
              return "de-BE";
        default:
            return "en-US"
      }
  }

  static convertLanguageInt(lang: string) {
    if (lang === "nl-BE") {
      return 1;
    } else if (lang === "fr-BE") {
      return 2;
    }else if (lang === "de-BE") {
      return 4;
    } else {
      return 3;
    }
  }

  static convertIntToFieldDataCode(lang: number) {
      switch(lang) {
          case 1:
              return 'NL';
          case 2:
              return 'FR';
          case 3:
              return 'EN';
          case 3:
              return 'DE';
          default:
                return 'EN'
            
      }
  }

  static getLanguageShortCode(lang: string)
  {
    return lang.substring(0, 2).toUpperCase();
  }
}
